import InviteVM from './invite-vm';

export default {
  init() {
    const validationOptions = {
      insertMessages: false,
      errorsAsTitle: true,
      decorateInputElement: true,
      parseInputAttributes: true,
      messagesOnModified: true,
      errorElementClass: 'error',
      errorMessageClass: 'error',
      decorateElementOnModified: true,
      decorateElement: true,
      grouping: { deep: true, observable: true, live: true }
    };

    const vm = new InviteVM();

    //
    //modify an existing templateEngine to work with string templates
    //
    const createStringTemplateEngine = (templateEngine, templates) => {
      templateEngine.makeTemplateSource = template => {
        return new ko.templateSources.stringTemplate(template, templates);
      };

      return templateEngine;
    };

    //
    //make this new template engine our default engine
    //
    ko.setTemplateEngine(
      createStringTemplateEngine(new ko.nativeTemplateEngine(), vm.templates)
    );

    ko.applyBindingsWithValidation(
      vm,
      document.getElementById('invite_student'),
      validationOptions
    );
  }
};

